import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=5a16cbcb&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a16cbcb')) {
      api.createRecord('5a16cbcb', component.options)
    } else {
      api.reload('5a16cbcb', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=5a16cbcb&", function () {
      api.rerender('5a16cbcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SearchBar.vue"
export default component.exports